import React from 'react';

import CreateEditCompanyFormUI from '../CreateEditCompanyFormUI';
import { companyStatus } from '../../constants';

const CreateCompanyDialog = (props) => {
  const {
    openDialog,
    openCreateCompanyDialog,
    onHandleInputChange,
    company,
    submitCompany,
    isSaving
  } = props;

  const handleSubmit = (e) => {
    e.preventDefault();
    const { company } = props;
    const payload = {
      ...company,
      status: companyStatus.ACTIVE
    };
    submitCompany(payload);
  };

  return (
    <React.Fragment>
      <CreateEditCompanyFormUI
        openDialog={openDialog}
        isSaving={isSaving}
        onHandleInputChange={onHandleInputChange}
        openCreateCompanyDialog={openCreateCompanyDialog}
        handleSubmit={handleSubmit}
        title="Create New Company"
        company={company}
      />
    </React.Fragment>
  );
};

export default CreateCompanyDialog;
